export default {
  getOptionWarranty: state => state.optionWarranty,
  // Bulk update warranty getters
  getBulkUpdateResults: state => state.bulkUpdateResults,
  getBulkUpdateHistory: state => state.bulkUpdateHistory,
  getBulkUpdateFilters: state => state.bulkUpdateFilters,
}
